export const reduceData = (data, fields) => {
	return (
		data.reduce(
			(prev, next) =>
				prev + fields.reduce((cPrev, cNext) => cPrev + next[cNext], 0),
			0,
		) || 0
	);
};
